import axios from "../../axiosInstance";
import type { Badge } from "@/modules/learningCenter/features/BadgeManagement/types/badge.types";

export const deactivateBadge = async (id: string): Promise<Badge> => {
  const response = await axios.post<Badge>(`/api/badges/${id}/deactivate`);
  return response.data;
};

export default deactivateBadge;
